<template>
    <div class="filter-list">
        <slot />
    </div>
</template>

<style lang="scss">
 .filter-list {
     display: flex;
     gap: 16px;
     align-items: center;
     margin-bottom: 16px;
     overflow-x: scroll;
     -webkit-overflow-scrolling: auto;

     /* Hide scrollbar for IE, Edge and Firefox */
     -ms-overflow-style: none; /* IE and Edge */
     scrollbar-width: none; /* Firefox */

     &::-webkit-scrollbar {
         display: none;
     }

     input {
         margin-inline-end: 5px;
     }
 }
</style>
